import { Navigate } from "react-router-dom";

import { RVRoutingPage } from "@regal-voice/ui";
import { usePageAvailability } from "App/routes/Hooks/usePageAvilability/usePageAvailability";
import { AppPagePaths } from "App/routes/paths";

export default function SipRouter(): JSX.Element {
    const { settingsPages } = usePageAvailability();

    if (!settingsPages.showSip) {
        return <Navigate to={AppPagePaths.fallback} />;
    }

    return <RVRoutingPage />;
}
